import { type ContextCollectionConsentRecord } from '@electron/shared/types';
import { useEffect } from 'react';

import { setUserProperties } from '@/utils/analytics';

export function useContextConsentAnalytics(
  userId: string | undefined,
  consent: ContextCollectionConsentRecord | undefined
) {
  const value = consent?.consent;
  const updatedAt = consent?.updatedAt;

  useEffect(() => {
    if (!userId || !value) return;
    setUserProperties({
      context_consent: value,
      context_consent_updated_at: updatedAt,
    });
  }, [userId, value, updatedAt]);
}
